<script>
	import { acceptedFileUploadList, projectSettings } from "../../config";
	import model from "../../stores/modelStore";

	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";

	export let pageTitle = null;
	export let persistUrl = null;

	let buttons = null;
	let id = "fileUploader";
	let documentList = [];
	let options = {
		url: "/api/file-upload?token=" + $model.RegistrationToken,
		acceptedFiles: acceptedFileUploadList
	};

	document.title = pageTitle;

	let documentUploadError = "";

	const validateDocuments = () => {
		let isValid = documentList.length > 0;
		documentUploadError = isValid ? "" : "Please upload documents";
		return isValid;
	};

	const getDocumentUploadError = () => {
		let isValid = validateDocuments();
		return isValid ? [] : [document.getElementById("docUploadError")];
	};

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = [...getDocumentUploadError()];

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
			} else {
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};
</script>

<PageSection>
	<Form id="form-document-upload" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Supporting Documentation</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<p>
			Please provide supporting documentation of your trading in James Hardie securities by using the upload box below.
			Supporting documents may include holding statements, buy and sell contract notes, CHESS statements or broker
			account statements.
		</p>
		<div class="form-row">
			<!-- <div class="form-row" transition:slide> -->
			<div class="form-group col-md-12">
				<DropZone {options} {id} message="Drop files here or click to upload for this loan." bind:documentList
				></DropZone>
			</div>
		</div>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons nextPageLabel={"Submit Files"} />
				<div
					id="docUploadError"
					class="error-message"
					style={documentUploadError ? "display: block" : "display: none"}>
					{documentUploadError}
				</div>
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>
